export default __webpack_public_path__ + "static/media/Screenshot 2022-05-30 at 3.35.52 PM.102ef140.png";